import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import { Promotion } from "@quest_editor/mocks";

const PromotionInfoSection = ({
  questId,
  promotion,
  getTypeLabel,
  buildOptionsDisplay,
}: {
  questId: string;
  promotion: Promotion;
  getTypeLabel: (type: string) => string;
  buildOptionsDisplay: (promotion: Promotion | null | undefined) => string[];
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.promotion_info")}
      rows={[
        {
          label: t("quest_detail.field.promotion_info.quest_id"),
          children: (
            <Typography color="text.secondary">{questId}</Typography>
          ),
        },
        {
          label: t("quest_detail.field.promotion_info.name"),
          children: (
            <Typography color="text.secondary">{promotion.name}</Typography>
          ),
        },
        {
          label: t("quest_detail.field.promotion_info.type"),
          children: (
            <Typography color="text.secondary">
              {getTypeLabel(promotion.type)}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.promotion_info.description"),
          children: (
            <Typography color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
              {promotion.description}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.promotion_info.option"),
          children: (
            <Stack direction="column" spacing={1}>
              {buildOptionsDisplay(promotion).map((opt, idx) => (
                <Typography key={idx} variant="body2" color="text.secondary">
                  {opt}
                </Typography>
              ))}
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default PromotionInfoSection;
